import React from "react";
import { Button, Box, styled } from "@mui/material";
import { colors } from "../../theme/colors";

const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "240px",
});

const OutlinedButton = styled(Button)({
  borderColor: colors.primary.main,
  color: colors.primary.main,
  "&:hover": {
    borderColor: colors.primary.dark,
    backgroundColor: "rgba(58, 138, 185, 0.04)",
  },
});

const AmberButton = styled(Button)({
  backgroundColor: colors.amber.main,
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: colors.amber.dark,
  },
});

const PrimaryButton = styled(Button)({
  backgroundColor: colors.primary.main,
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: colors.primary.dark,
  },
});

interface SharePopoverContentProps {
  onDownloadPdf: () => void;
  onEmailForReview: () => void;
  onOpenToSign: () => void;
  status?: number;
}

/**
 * Open to Sign and Email For Review available for:
 * 3: AwaitingPatientConfirmation
 * 4: DeclinedByPatient
 * 6: InProgress
 */
const SharePopoverContent: React.FC<SharePopoverContentProps> = ({
  onDownloadPdf,
  onEmailForReview,
  onOpenToSign,
  status,
}) => {
  // Available for statuses 3 (AwaitingPatientConfirmation), 4 (DeclinedByPatient), 6 (InProgress)
  const isShareActionsAvailable =
    status === 3 || status === 4 || status === 6;

  return (
    <ContentContainer>
      <OutlinedButton variant="outlined" fullWidth onClick={onDownloadPdf}>
        Download As PDF
      </OutlinedButton>
      {isShareActionsAvailable && (
        <AmberButton variant="contained" fullWidth onClick={onEmailForReview}>
          Email For Review
        </AmberButton>
      )}
      {isShareActionsAvailable && (
        <PrimaryButton variant="contained" fullWidth onClick={onOpenToSign}>
          Open To Sign
        </PrimaryButton>
      )}
    </ContentContainer>
  );
};

export default SharePopoverContent;

